import { HeaderWithIcon } from 'shared/ui/header-with-icon'
import { HeaderVariant } from 'shared/ui/header/header'

interface Props {
  headerVariant?: HeaderVariant
  backgroundColor?: string
  isFixed?: boolean
}

export const HeaderProfile = ({
  headerVariant,
  backgroundColor,
  isFixed,
}: Props) => {
  return (
    <HeaderWithIcon
      headerVariant={headerVariant}
      backgroundColor={backgroundColor}
      isFixed={isFixed}
    />
  )
}
